import styled, { CSSProperties } from "styled-components";
import { StyledTabsHead, StyledTabsButton } from "../../styles";
import { defaultTheme } from "storybook/themes/default";
import { Variant } from "../../types";

export { TabsBtnSoft, TabsBtnHeavy, TabsBtnContained } from "./variants";

const { colors } = defaultTheme;

const getBackgroundColors = (variant: Variant) => {
  if (variant === "contained") return colors.greyBright;
  if (variant === "heavy-underline") return colors.white;
  if (variant === "soft-underline") return colors.greyBright;

  return "transparent";
};

export const StyledTabsHeadDefault = styled(StyledTabsHead)<{
  $mobileStackTabs: boolean;
  $variant: Variant;
  $height: CSSProperties["height"];
}>`
  position: relative;
  flex-direction: column;
  height: ${({ $height }) => $height || "auto"};
  padding: ${({ $variant }) => ($variant === "contained" ? "2px" : "0px")};
  background-color: ${({ $variant }) => getBackgroundColors($variant)};
  border-top: ${({ $variant }) =>
    $variant === "heavy-underline" ? "1px solid #D4D4D4" : "none"};
  border-bottom: ${({ $variant }) =>
    $variant !== "contained" ? "1px solid #D4D4D4" : "none"};
  border-radius: ${({ $variant }) =>
    $variant === "contained" ? "0.5rem" : "none"};
  align-items: flex-start;

  ${({ $variant }) => $variant === "heavy-underline" && "margin-bottom: 0;"}
  ${({ $variant }) => $variant === "soft-underline" && "margin-bottom: 0;"}

  ${({ $mobileStackTabs }) =>
    !$mobileStackTabs
      ? "flex-direction: row;"
      : `
      @media (min-width: 600px) {
        flex-direction: row;
      }
  `};
`;

export const StyledTabTextDefault = styled.div`
  font-size: 1.125rem;
  letter-spacing: 0.5px;
  font-family: ${defaultTheme.typography.fontFamily};
`;

export const StyledTabsButtonDefault = styled(StyledTabsButton)<{
  $disabled?: boolean;
  $mobileStackTabs: boolean;
  $variant: Variant;
  $maxWidth: string;
}>`
  color: ${colors.ciqBrand};
  box-sizing: border-box;
  padding: 8px 14px;
  border-radius: 0.5rem;
  line-height: 23px;
  font-size: 1.125rem;
  max-width: ${({ $maxWidth }) => $maxWidth || "100%"};

  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: center;

  ${({ $disabled }) =>
    $disabled &&
    `
    cursor: not-allowed;
    color: ${colors.grey};
  `}

  // IE11
  *::-ms-backdrop,
  & {
    padding: 20px;

    ${({ $mobileStackTabs }) =>
      $mobileStackTabs &&
      `@media (min-width: 600px) {
         padding: 8px 14px;
       }
      `}
  }
`;

export const StyledTabsButtonActiveDefault = styled(StyledTabsButtonDefault)`
  cursor: default;
  color: ${colors.hematite};
  background-color: ${colors.white};
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
`;
